import React from 'react'
import { useTheme } from '@mui/material'
import SvgWrapper from '../SvgWrapper'
import { ICON_SIZE, ICON_VIEWBOX } from './constants'
import type { IconProps } from './types'

const StatusTimelineClosed: React.FC<IconProps> = ({ size = ICON_SIZE.tiny, viewBox = ICON_VIEWBOX.tiny }) => {
  const { palette } = useTheme()

  return (
    <SvgWrapper aria-label="Status Timeline Closed" size={size} viewBox={viewBox}>
      <circle cx="6" cy="6" r="6" fill={palette.primary.main} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.808 3.606a.5.5 0 0 1 .086.702l-3.125 4a.5.5 0 0 1-.759.034l-1.875-2a.5.5 0 0 1 .73-.684L5.34 7.232l2.766-3.54a.5.5 0 0 1 .702-.086z"
        fill={palette.common.white}
      />
    </SvgWrapper>
  )
}

export default StatusTimelineClosed
